<template>
  <v-container class="main-container responsive-height">
    <UserStatistics></UserStatistics>
    <AllLinks></AllLinks>
    <v-row dense>
      <v-col cols="12" md="12">
        <v-card
          tile
          flat
          class="userBriefHistory"
          :class="$vuetify.theme.dark ? 'blue-darken-2 ' : 'white-lighten-2'"
        >
          <v-container>
            <v-row dense>
              <v-col cols="12">
                <v-sheet
                  :class="$vuetify.theme.dark ? 'blue-darken-2 ' : 'transparent'"
                >
                  <div class="d-flex align-center mb-4 justify-space-between flex-column flex-sm-row">
                    <div class="title">
                      <span>Special Account Type & Commissions</span>
                      <router-link class="links pr-0 ml-3" to="/commission-statistics">
                        See Details >
                      </router-link>
                    </div>
                    <div class="startingTips">
                      <p class="d-flex" v-if="this.acctypesbook"><v-icon class="mr-1" left color="#039DE9">mdi-currency-usd-off</v-icon> Profit Percentage: {{ this.acctypesbook }}%</p>
                    </div>
                  </div>
                  <div class="account-types-buttons">
                    <v-btn
                      v-for="type in acctypes"
                      :key="type?.id"
                      outlined
                      rounded
                      color="#3F546B"
                      class="text-capitalize mx-1"
                      @click="handleAccountTypeClick(type)"
                    >
                      {{ type?.account_type_display }}
                    </v-btn>
                  </div>
                </v-sheet>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
    <IbCommissionTable></IbCommissionTable>
    <ClientLevelChart></ClientLevelChart>
  </v-container>
</template>

<script>
import AllLinks from "@/components/Dashboard/AllLinks.vue";
import ClientLevelChart from "@/components/Dashboard/ClientLevelChart.vue";
import IbCommissionTable from "@/components/Dashboard/IbCommissionTable.vue";
import UserStatistics from "@/components/Dashboard/UserStatistics.vue";

import { mapState, mapActions } from "vuex";
import { ASSACCTYPES__ACTIONS } from "@/store/action-types";

export default {
  components: {
    UserStatistics,
    AllLinks,
    IbCommissionTable,
    ClientLevelChart,
  },
  
  computed: {
    ...mapState("acctypes", ["acctypes","acctypesbook"]),
  },

  methods: {
    ...mapActions("acctypes", [ASSACCTYPES__ACTIONS.ASSIGNEDACCTYPES]),
  },

  async mounted() {
    await this[ASSACCTYPES__ACTIONS.ASSIGNEDACCTYPES]();
  },
};
</script>